<template>
  <div>
    <bar-chart :xdata="xdata" :series="series" :rotate="0" :type="status"  :barcolor='barcolor' :height="height"/>
  </div>
</template>
  <script>
import BarChart from '@/components/layouts/BarChartRevote';
import * as echarts from 'echarts';
export default {
  computed: {
    xdata() {
      let arr = [];
      this.hospitalArr.map((item) => {
        arr.push(item.hospitalName ? item.hospitalName : item.sicknessName);
      });
      return arr;
    },
    series() {
      let data = [];
      this.hospitalArr.map((item) => {
        data.push({
          name: item.hospitalName || item.sicknessName,
          value:
            this.status == 'hospital' ? item.hospitalNum : this.status == 'illness' ? item.caseNum : item.totalAmount,
        });
      });
      // this.height=this.hospitalArr.length*50+'px';
      return [
        {
          type: 'bar',
          stack: 'vistors',
          barWidth: 18,
          data: data,
          animationDuration: 2000,
          itemStyle:{
            normal:{
              label:{
                formatter:this.status == 'illness' ? "{c}"+"次":"平均"+"{c}"+"元",
                show: true,
                  position: "right",
                  color:this.status == "illness"?'#63C4C7':'#70AFEA',
                  // fontSize:'12px',
              }
            }
          }
        },
      ];
    },
  },
  data(){
    return {
      getBarcolor:'#63C4C7',
      height:'500px',
    }
  },
  props: {
    hospitalArr: {
      type: Array,
      default: () => [],
    },
    status: {
      type: String,
      default: 'hospital', //来标识取值用
    },
    barcolor:{
      type:String,
      default:'#63C4C7'
    }
  },
  components: {
    BarChart,
  },
};
</script>